(async () => {
  "use strict";

  const data = getData();
  const details = getDetails();
  const detailHeaders = getDetailHeaders();
  const hardCodeData = getHardCodeData();

  // console.log("fetching");
  // await fetchProducts();
  // console.log("done");

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    addStyle();
    addCompareBtnPDP();
    addComparePopup();
    handleEvents();
    assignCssVariables();
  }

  function addStyle() {
    let style = document.createElement("style");
    style = document.createElement("style");
    style.textContent = `
      body:has(.compare-popup.show) {
        overflow: hidden;
      }
      .compare-popup.tv_compare_popup {
        top: 0px;
      }
      .compare-popup {
        --nav-height: 0px;
        display: none;
        position: fixed;
        inset: 0;
        width: 100%;
        height: calc(100dvh - var(--nav-height));
        margin-top: var(--nav-height);
        background: #fff;
        overflow: auto;
        z-index: 9999999;
      }
      .compare-popup-close-btn {
        position: fixed;
        top: calc(var(--nav-height) + 1rem);
        right: 1rem;
        display: flex;
        cursor: pointer;
        z-index: 3;
      }
      .compare-popup-close-btn svg {
        width: 30px;
        height: 30px;
      }
      .compare-popup-close-btn:active svg {
        transform: scale(0.95);
      }
      .compare-popup p {
        margin: 0;
      }
      .compare-popup p.title {
        width: 100%;
        margin-top: 1rem;
        text-align: center;
        font-size: 28px;
        font-weight: 700;
      }
      .compare-popup p.subtitle {
        width: 100%;
        text-align: center;
        font-size: 14px;
      }
      .compare-popup .details_wrapper {
        grid-column: 1 / -1;
      }
      
      .tv_compare_popup .details-title {
        padding: 1rem 0.5rem;
        margin: 0px;
        margin-bottom: 1rem;
        border-bottom: 1px solid black;
        font-weight: 700;
        font-size: 26px;
      }
      .tv_compare_popup p {
        margin: 0px;
      }
      .tv_compare_popup p.details-value {
        margin-bottom: 1rem;
      }
      .tv_compare_popup table {
        table-layout: fixed;
        margin-bottom: 0;
        overflow-x: auto;
      }
      .tv_compare_popup table th {
        padding-block: 0;
        font-size: 14px;
      }
      .tv_compare_popup table td {
        padding-top: 0;
        padding-bottom: 1rem;
        vertical-align: top;
        font-size: 14px;
      }
      .tv_compare_popup table td.tv-size {
        font-size: 32px;
        font-weight: 700;
      }
      .tv_compare_popup table th:last-child,
      .tv_compare_popup table td:last-child {
        display: none;
      }
      table[data-section='summary'] td {
        padding-bottom: 2rem;
      }
      table[data-section='summary'] td img {
        max-width: 100px;
      }
      @media (min-width: 1024px) {
        .tv_compare_btn {
          position: absolute;
          top: 0;
          right: 0;
        }
        .tv_compare_popup .details-title {
          font-size: 32px;
        }
        .tv_compare_popup table th,
        .tv_compare_popup table td {
          font-size: 16px;
        }
        .tv_compare_popup table th:last-child,
        .tv_compare_popup table td:last-child {
          display: block;
        }
        table[data-section='summary'] td img {
          max-width: 180px;
        }
      }
    `;
    document.head.append(style);
  }

  function addCompareBtnPDP() {
    const button = document.createElement("button");
    button.classList.add("btn", "spec-button", "pdp-compare-btn");
    button.textContent = "Compare";
    $(".nav2-content .spacer").after(button);
  }

  function addComparePopup() {
    const comparePopup = document.createElement("div");
    comparePopup.classList.add("compare-popup", "tv_compare_popup");
    comparePopup.innerHTML = `
      <div class="compare-popup-close-btn">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"/></svg>
      </div>
      <div class="page-width">
        <p class="title">Compare TV Models</p>
        <p class="subtitle">Discover your perfect entertainment companion - choose the right TV for an immersive viewing experience!</p>
        <div class="compare_list"></div>
      </div>
    `;
    document.body.append(comparePopup);

    renderComparePopup();
  }

  function renderComparePopup() {
    renderTopSection();
    renderBottomSection();
  }

  function renderTopSection() {
    const compare_list = $(".compare-popup").find(".compare_list");

    for (const x in [...Array(3).keys()]) {
      const rowIndex = Number(x);
      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const colData = data[colIndex];
        const productHardCodeData =
          hardCodeData[colData.groupProducts[0].handle];

        switch (rowIndex) {
          case 0:
            const section_select = document.createElement("div");
            section_select.classList.add("section_select");
            section_select.setAttribute("data-index", colIndex + 1);
            compare_list.append(section_select);
            section_select.innerHTML = `
              <div class="select">
                <div class="trigger">
                  <span>${colData.groupName}</span>
                </div>
                <div class="options">
                  ${data.map((x, i) => `<div class="option ${i == colIndex ? "selected" : ""}">${x.groupName}</div>`).join("")}
                </div>
              </div>
            `;
            break;

          case 1:
            const section_prodImg = document.createElement("div");
            section_prodImg.classList.add("section_prodImg");
            section_prodImg.setAttribute("data-index", colIndex + 1);
            compare_list.append(section_prodImg);
            section_prodImg.innerHTML = `<img src="${productHardCodeData?.img || ""}" alt="" width="" height="" />`;
            break;

          case 2:
            const section_prodInfo = document.createElement("div");
            section_prodInfo.classList.add("section_prodInfo");
            section_prodInfo.setAttribute("data-index", colIndex + 1);
            compare_list.append(section_prodInfo);
            section_prodInfo.innerHTML = `
              <div class="text-center">Available TV Sizes</div>
              <div class="options">
                ${colData.groupProducts.map((x, i) => `<button class="${i == 0 ? "selected" : ""}" type="button" data-product-handle="${x.handle}">${x.size}</button>`).join("")}
              </div>
              <div class="price_wrapper">
                <span class="product-price__price with-voucher">
                  <img width="20" height="20" src="//prismplus.sg/cdn/shop/t/29/assets/voucher-icon.svg?v=96074962922774460831748329629" />
                  <span class="price-wrapper">${theme.Currency.formatMoney(productHardCodeData?.price || 0)}</span>
                </span>
                <s class="product-price__price product-compare">${theme.Currency.formatMoney(productHardCodeData?.compare_at_price || 0)}</s>
              </div>
              <div class="cta_wrapper">
                <a href="/products/${colData.groupProducts[0].handle}">${colData.ctaText}</a>
              </div>
            `;
            break;

          default:
            break;
        }
      }
    }

    const details_wrapper = document.createElement("div");
    details_wrapper.classList.add("details_wrapper");
    compare_list.append(details_wrapper);
  }

  function renderBottomSection() {
    const details_wrapper = $(".compare-popup").find(".details_wrapper");

    const title_summary = document.createElement("p");
    title_summary.classList.add("details-title");
    title_summary.innerHTML = "Summary";
    details_wrapper.append(title_summary);

    const table_summary = document.createElement("table");
    table_summary.setAttribute("data-section", "summary");
    table_summary.innerHTML = `<tbody></tbody>`;
    details_wrapper.append(table_summary);

    for (const x in [...Array(13).keys()]) {
      const rowIndex = Number(x);
      const row_el = document.createElement("tr");
      table_summary.querySelector("tbody").append(row_el);

      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const cell_el = document.createElement("td");
        row_el.append(cell_el);

        const colData = data[colIndex];

        if (rowIndex == 0) {
          cell_el.classList.add("tv-size");
          cell_el.innerHTML = colData.groupProducts[0].size;
        } else {
          const cellData =
            details[colData.groupProducts[0].handle][rowIndex - 1];
          cell_el.innerHTML = `<img src="${cellData}" alt="" width="" height="" />`;
        }
      }
    }

    const title_display = document.createElement("p");
    title_display.classList.add("details-title");
    title_display.innerHTML = "Display";
    details_wrapper.append(title_display);

    const table_display = document.createElement("table");
    table_display.setAttribute("data-section", "display");
    table_display.innerHTML = `<tbody></tbody>`;
    details_wrapper.append(table_display);

    for (const x in [...Array(14).keys()]) {
      const rowIndex = Number(x);
      const row_el_header = document.createElement("tr");
      const row_el_detail = document.createElement("tr");
      table_display.querySelector("tbody").append(row_el_header, row_el_detail);

      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const cell_el_header = document.createElement("th");
        const cell_el_detail = document.createElement("td");
        row_el_header.append(cell_el_header);
        row_el_detail.append(cell_el_detail);

        const colData = data[colIndex];

        const rowHeader = detailHeaders[rowIndex];
        cell_el_header.innerHTML = rowHeader;

        const rowDetail =
          details[colData.groupProducts[0].handle][rowIndex - 1 + 13];
        cell_el_detail.innerHTML = rowDetail;
      }
    }

    const title_audio = document.createElement("p");
    title_audio.classList.add("details-title");
    title_audio.innerHTML = "Audio";
    details_wrapper.append(title_audio);

    const table_audio = document.createElement("table");
    table_audio.setAttribute("data-section", "audio");
    table_audio.innerHTML = `<tbody></tbody>`;
    details_wrapper.append(table_audio);

    for (const x in [...Array(5).keys()]) {
      const rowIndex = Number(x) + 14;
      const row_el_header = document.createElement("tr");
      const row_el_detail = document.createElement("tr");
      table_audio.querySelector("tbody").append(row_el_header, row_el_detail);

      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const cell_el_header = document.createElement("th");
        const cell_el_detail = document.createElement("td");
        row_el_header.append(cell_el_header);
        row_el_detail.append(cell_el_detail);

        const colData = data[colIndex];

        const rowHeader = detailHeaders[rowIndex];
        cell_el_header.innerHTML = rowHeader;

        const rowDetail =
          details[colData.groupProducts[0].handle][rowIndex - 1 + 13];
        cell_el_detail.innerHTML = rowDetail;
      }
    }

    const title_features = document.createElement("p");
    title_features.classList.add("details-title");
    title_features.innerHTML = "Features";
    details_wrapper.append(title_features);

    const table_features = document.createElement("table");
    table_features.setAttribute("data-section", "features");
    table_features.innerHTML = `<tbody></tbody>`;
    details_wrapper.append(table_features);

    for (const x in [...Array(7).keys()]) {
      const rowIndex = Number(x) + 14 + 5;
      const row_el_header = document.createElement("tr");
      const row_el_detail = document.createElement("tr");
      table_features
        .querySelector("tbody")
        .append(row_el_header, row_el_detail);

      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const cell_el_header = document.createElement("th");
        const cell_el_detail = document.createElement("td");
        row_el_header.append(cell_el_header);
        row_el_detail.append(cell_el_detail);

        const colData = data[colIndex];

        const rowHeader = detailHeaders[rowIndex];
        cell_el_header.innerHTML = rowHeader;

        const rowDetail =
          details[colData.groupProducts[0].handle][rowIndex - 1 + 13];
        cell_el_detail.innerHTML = rowDetail;
      }
    }

    const title_size_weight = document.createElement("p");
    title_size_weight.classList.add("details-title");
    title_size_weight.innerHTML = "Size & Weight";
    details_wrapper.append(title_size_weight);

    const table_size_weight = document.createElement("table");
    table_size_weight.setAttribute("data-section", "size_weight");
    table_size_weight.innerHTML = `<tbody></tbody>`;
    details_wrapper.append(table_size_weight);

    for (const x in [...Array(5).keys()]) {
      const rowIndex = Number(x) + 14 + 5 + 7 + 1;
      const row_el_header = document.createElement("tr");
      const row_el_detail = document.createElement("tr");
      table_size_weight
        .querySelector("tbody")
        .append(row_el_header, row_el_detail);

      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const cell_el_header = document.createElement("th");
        const cell_el_detail = document.createElement("td");
        row_el_header.append(cell_el_header);
        row_el_detail.append(cell_el_detail);

        const colData = data[colIndex];

        const rowHeader = detailHeaders[rowIndex];
        cell_el_header.innerHTML = rowHeader;

        const rowDetail =
          details[colData.groupProducts[0].handle][rowIndex - 1 + 13];
        cell_el_detail.innerHTML = rowDetail;
      }
    }

    const title_connectivity = document.createElement("p");
    title_connectivity.classList.add("details-title");
    title_connectivity.innerHTML = "Connectivity";
    details_wrapper.append(title_connectivity);

    const table_connectivity = document.createElement("table");
    table_connectivity.setAttribute("data-section", "connectivity");
    table_connectivity.innerHTML = `<tbody></tbody>`;
    details_wrapper.append(table_connectivity);

    for (const x in [...Array(11).keys()]) {
      const rowIndex = Number(x) + 14 + 5 + 7 + 5;
      const row_el_header = document.createElement("tr");
      const row_el_detail = document.createElement("tr");
      table_connectivity
        .querySelector("tbody")
        .append(row_el_header, row_el_detail);

      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const cell_el_header = document.createElement("th");
        const cell_el_detail = document.createElement("td");
        row_el_header.append(cell_el_header);
        row_el_detail.append(cell_el_detail);

        const colData = data[colIndex];

        const rowHeader = detailHeaders[rowIndex];
        cell_el_header.innerHTML = rowHeader;

        const rowDetail =
          details[colData.groupProducts[0].handle][rowIndex - 1 + 13];
        cell_el_detail.innerHTML = rowDetail;
      }
    }
  }

  function updateDetailsWrapper(handles = ["", "", ""]) {
    const details_wrapper = $(".compare-popup").find(".details_wrapper");
    details_wrapper.empty();

    handles.forEach((handle, index) => {
      const groupData = data.find((x) =>
        x.groupProducts.find((x) => x.handle == handle),
      );
      const productData = groupData.groupProducts.find(
        (x) => x.handle == handle,
      );
      const productHardCodeData = hardCodeData[handle];

      $(`.section_prodImg[data-index="${index + 1}"] img`).attr(
        "src",
        productHardCodeData?.img || "",
      );
      $(
        `.section_prodInfo[data-index="${index + 1}"] .price_wrapper .price-wrapper`,
      ).html(theme.Currency.formatMoney(productHardCodeData?.price || 0));
      $(
        `.section_prodInfo[data-index="${index + 1}"] .price_wrapper .product-compare`,
      ).html(
        theme.Currency.formatMoney(productHardCodeData?.compare_at_price || 0),
      );
      $(`.section_prodInfo[data-index="${index + 1}"] .cta_wrapper a`).html(
        groupData.ctaText,
      );
      $(`.section_prodInfo[data-index="${index + 1}"] .cta_wrapper a`).attr(
        "href",
        `/products/${handle}`,
      );
    });

    const title_summary = document.createElement("p");
    title_summary.classList.add("details-title");
    title_summary.innerHTML = "Summary";
    details_wrapper.append(title_summary);

    const table_summary = document.createElement("table");
    table_summary.setAttribute("data-section", "summary");
    table_summary.innerHTML = `<tbody></tbody>`;
    details_wrapper.append(table_summary);

    for (const x in [...Array(13).keys()]) {
      const rowIndex = Number(x);
      const row_el = document.createElement("tr");
      table_summary.querySelector("tbody").append(row_el);

      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const cell_el = document.createElement("td");
        row_el.append(cell_el);

        const colData = data.find((x) =>
          x.groupProducts.find((x) => x.handle == handles[colIndex]),
        );
        const colProduct = colData.groupProducts.find(
          (x) => x.handle == handles[colIndex],
        );

        if (rowIndex == 0) {
          cell_el.classList.add("tv-size");
          cell_el.innerHTML = colProduct.size;
        } else {
          const cellData = details[handles[colIndex]][rowIndex - 1];
          cell_el.innerHTML = `<img src="${cellData}" alt="" width="" height="" />`;
        }
      }
    }

    const title_display = document.createElement("p");
    title_display.classList.add("details-title");
    title_display.innerHTML = "Display";
    details_wrapper.append(title_display);

    const table_display = document.createElement("table");
    table_display.setAttribute("data-section", "display");
    table_display.innerHTML = `<tbody></tbody>`;
    details_wrapper.append(table_display);

    for (const x in [...Array(14).keys()]) {
      const rowIndex = Number(x);
      const row_el_header = document.createElement("tr");
      const row_el_detail = document.createElement("tr");
      table_display.querySelector("tbody").append(row_el_header, row_el_detail);

      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const cell_el_header = document.createElement("th");
        const cell_el_detail = document.createElement("td");
        row_el_header.append(cell_el_header);
        row_el_detail.append(cell_el_detail);

        const colData = data.find((x) =>
          x.groupProducts.find((x) => x.handle == handles[colIndex]),
        );

        const rowHeader = detailHeaders[rowIndex];
        cell_el_header.innerHTML = rowHeader;

        const rowDetail = details[handles[colIndex]][rowIndex - 1 + 13];
        cell_el_detail.innerHTML = rowDetail;
      }
    }

    const title_audio = document.createElement("p");
    title_audio.classList.add("details-title");
    title_audio.innerHTML = "Audio";
    details_wrapper.append(title_audio);

    const table_audio = document.createElement("table");
    table_audio.setAttribute("data-section", "audio");
    table_audio.innerHTML = `<tbody></tbody>`;
    details_wrapper.append(table_audio);

    for (const x in [...Array(5).keys()]) {
      const rowIndex = Number(x) + 14;
      const row_el_header = document.createElement("tr");
      const row_el_detail = document.createElement("tr");
      table_audio.querySelector("tbody").append(row_el_header, row_el_detail);

      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const cell_el_header = document.createElement("th");
        const cell_el_detail = document.createElement("td");
        row_el_header.append(cell_el_header);
        row_el_detail.append(cell_el_detail);

        const colData = data.find((x) =>
          x.groupProducts.find((x) => x.handle == handles[colIndex]),
        );

        const rowHeader = detailHeaders[rowIndex];
        cell_el_header.innerHTML = rowHeader;

        const rowDetail = details[handles[colIndex]][rowIndex - 1 + 13];
        cell_el_detail.innerHTML = rowDetail;
      }
    }

    const title_features = document.createElement("p");
    title_features.classList.add("details-title");
    title_features.innerHTML = "Features";
    details_wrapper.append(title_features);

    const table_features = document.createElement("table");
    table_features.setAttribute("data-section", "features");
    table_features.innerHTML = `<tbody></tbody>`;
    details_wrapper.append(table_features);

    for (const x in [...Array(7).keys()]) {
      const rowIndex = Number(x) + 14 + 5;
      const row_el_header = document.createElement("tr");
      const row_el_detail = document.createElement("tr");
      table_features
        .querySelector("tbody")
        .append(row_el_header, row_el_detail);

      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const cell_el_header = document.createElement("th");
        const cell_el_detail = document.createElement("td");
        row_el_header.append(cell_el_header);
        row_el_detail.append(cell_el_detail);

        const colData = data.find((x) =>
          x.groupProducts.find((x) => x.handle == handles[colIndex]),
        );

        const rowHeader = detailHeaders[rowIndex];
        cell_el_header.innerHTML = rowHeader;

        const rowDetail = details[handles[colIndex]][rowIndex - 1 + 13];
        cell_el_detail.innerHTML = rowDetail;
      }
    }

    const title_size_weight = document.createElement("p");
    title_size_weight.classList.add("details-title");
    title_size_weight.innerHTML = "Size & Weight";
    details_wrapper.append(title_size_weight);

    const table_size_weight = document.createElement("table");
    table_size_weight.setAttribute("data-section", "size_weight");
    table_size_weight.innerHTML = `<tbody></tbody>`;
    details_wrapper.append(table_size_weight);

    for (const x in [...Array(5).keys()]) {
      const rowIndex = Number(x) + 14 + 5 + 7 + 1;
      const row_el_header = document.createElement("tr");
      const row_el_detail = document.createElement("tr");
      table_size_weight
        .querySelector("tbody")
        .append(row_el_header, row_el_detail);

      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const cell_el_header = document.createElement("th");
        const cell_el_detail = document.createElement("td");
        row_el_header.append(cell_el_header);
        row_el_detail.append(cell_el_detail);

        const colData = data.find((x) =>
          x.groupProducts.find((x) => x.handle == handles[colIndex]),
        );

        const rowHeader = detailHeaders[rowIndex];
        cell_el_header.innerHTML = rowHeader;

        const rowDetail = details[handles[colIndex]][rowIndex - 1 + 13];
        cell_el_detail.innerHTML = rowDetail;
      }
    }

    const title_connectivity = document.createElement("p");
    title_connectivity.classList.add("details-title");
    title_connectivity.innerHTML = "Connectivity";
    details_wrapper.append(title_connectivity);

    const table_connectivity = document.createElement("table");
    table_connectivity.setAttribute("data-section", "connectivity");
    table_connectivity.innerHTML = `<tbody></tbody>`;
    details_wrapper.append(table_connectivity);

    for (const x in [...Array(11).keys()]) {
      const rowIndex = Number(x) + 14 + 5 + 7 + 5;
      const row_el_header = document.createElement("tr");
      const row_el_detail = document.createElement("tr");
      table_connectivity
        .querySelector("tbody")
        .append(row_el_header, row_el_detail);

      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const cell_el_header = document.createElement("th");
        const cell_el_detail = document.createElement("td");
        row_el_header.append(cell_el_header);
        row_el_detail.append(cell_el_detail);

        const colData = data.find((x) =>
          x.groupProducts.find((x) => x.handle == handles[colIndex]),
        );

        const rowHeader = detailHeaders[rowIndex];
        cell_el_header.innerHTML = rowHeader;

        const rowDetail = details[handles[colIndex]][rowIndex - 1 + 13];
        cell_el_detail.innerHTML = rowDetail;
      }
    }
  }

  function handleEvents() {
    const compareBtn = $(".compare-btn, .pdp-compare-btn");
    const comparePopup = $(".compare-popup");
    const closeBtn = comparePopup.find(".compare-popup-close-btn");
    const select = comparePopup.find(".select");
    const trigger = select.find(".trigger");
    const option = select.find(".option");

    compareBtn.on("click", function () {
      comparePopup.toggleClass("show");
    });
    closeBtn.on("click", function () {
      comparePopup.removeClass("show");
    });
    trigger.on("click", function () {
      $(this).closest(".select").toggleClass("open");
    });
    option.on("click", function () {
      $(this).siblings().removeClass("selected");
      $(this).addClass("selected");
      $(this).closest(".select").removeClass("open");
      $(this).closest(".select").find(".trigger span").html($(this).text());
      const index = $(this).closest(".section_select").attr("data-index");
      $(`.section_prodInfo[data-index="${index}"] .options`).html("");

      const groupData = data.find((x) => x.groupName == $(this).text());

      groupData.groupProducts.forEach((x, i) => {
        const button = document.createElement("button");
        button.type = "button";
        button.innerHTML = x.size;
        $(button).attr("data-product-handle", x.handle);
        if (i == 0) {
          button.classList.add("selected");
        }
        $(`.section_prodInfo[data-index="${index}"] .options`).append(button);
      });

      const handles = $(".section_prodInfo button.selected")
        .map((i, x) => $(x).attr("data-product-handle"))
        .get();
      updateDetailsWrapper(handles);
    });
    comparePopup.on("click", ".section_prodInfo button", function () {
      $(this).siblings().removeClass("selected");
      $(this).addClass("selected");

      const handles = $(".section_prodInfo button.selected")
        .map((i, x) => $(x).attr("data-product-handle"))
        .get();
      updateDetailsWrapper(handles);
    });
  }

  function assignCssVariables() {
    const comparePopup = $(".compare-popup")[0];

    setInterval(() => {
      comparePopup.style.setProperty(
        "--nav-height",
        `${$("#shopify-section-header").height()}px`,
      );
    }, 50);
  }

  async function fetchProducts() {
    for (const x of data) {
      for (const groupProduct of x.groupProducts) {
        const product = await getProduct(groupProduct.handle);
        groupProduct.image = product.featured_image;
        groupProduct.price = product.price;
        groupProduct.compare_at_price = product.compare_at_price;

        if (product.price == 0) {
          let displayPrice = product.price_max;
          for (const variant of product.variants) {
            if (variant.price != 0 && variant.price < displayPrice) {
              displayPrice = variant.price;
            }
          }
          groupProduct.price = displayPrice;
        }
      }
    }
  }

  function getData() {
    const data = [
      {
        groupName: "Q Series Ultra QLED+ Google TV 2026 Model",
        ctaText: "Shop QLED Google TVs 2026 Model",
        groupProducts: [
          { handle: "q43u-2026", size: "43″" },
          { handle: "q55u-2026", size: "55″" },
          { handle: "q65u-2026", size: "65″" },
          { handle: "q75u-2026", size: "75″" },
          { handle: "q85u-2026", size: "85″" },
          { handle: "prism-q100-ultra-qled-google-tv", size: "100″" },
        ],
      },
      {
        groupName: "Q Series QE Google TV 2026 Model",
        ctaText: "Shop Quantum Edition TVs 2026 Model",
        groupProducts: [
          { handle: "q43qe-2026", size: "43″" },
          { handle: "q55qe-2026", size: "55″" },
          { handle: "q65qe-2026", size: "65″" },
          { handle: "q75qe-2026", size: "75″" },
        ],
      },
      {
        groupName: "U Series 2026 Model",
        ctaText: "Shop U Series 2026 Model",
        groupProducts: [
          { handle: "u55-2026", size: "55″" },
          { handle: "u65-2026", size: "65″" },
          { handle: "u75-2026", size: "75″" },
        ],
      },
      // {
      //   groupName: "Q Series Ultra QLED+ Google TV",
      //   ctaText: "Shop QLED Google TVs",
      //   groupProducts: [],
      // },
      {
        groupName: "U Series Mini-LED Google TV",
        ctaText: "Shop Mini-LED Google  TVs",
        groupProducts: [
          { handle: "u75-qled-mini-led-google", size: "75″" },
          // { handle: "prism-u86-qd-mini-led", size: "86″" },
        ],
      },
      {
        groupName: "U Ultra-Series Mini-LED Google TV",
        ctaText: "Shop Ultra Mini-LED Google  TVs",
        groupProducts: [
          {
            handle: "prism-u55-ultra-qd-mini-led-4k-ai-google-tv",
            size: "55″",
          },
          {
            handle: "prism-u65-ultra-qd-mini-led-4k-ai-google-tv",
            size: "65″",
          },
          {
            handle: "prism-u75-ultra-qd-mini-led-4k-ai-google-tv",
            size: "75″",
          },
          {
            handle: "prism-u86-ultra-qd-mini-led-4k-ai-google-tv",
            size: "86″",
          },
        ],
      },
      {
        groupName: "S Series DLED TV",
        ctaText: "Shop DLED TVs",
        groupProducts: [
          { handle: "s32-google-tv", size: "32″" },
          { handle: "prism-s40-google-tv", size: "40″" },
          { handle: "prism-s43-google-tv", size: "43″" },
        ],
      },
      {
        groupName: "AL Series OLED TV",
        ctaText: "Shop OLED TVs",
        groupProducts: [
          { handle: "prism-55al-google-tv", size: "55″" },
          { handle: "prism-65al-google-tv", size: "65″" },
        ],
      },
    ];

    return data;
  }

  function getHardCodeData() {
    const data = {
      default: {
        price: 0,
        compare_at_price: 0,
        img: "",
      },
      "q43u-2026": {
        price: 54900,
        compare_at_price: 99900,
        img: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Q43U-MA-web1_bc860292-0e92-4521-9f7b-4747c20deb5b.jpg?v=1773626695",
      },
      "q55u-2026": {
        price: 89900,
        compare_at_price: 149900,
        img: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Q55U-MA-web1_731beb19-510e-4b3e-b86f-8f881dba4f99.jpg?v=1773626668",
      },
      "q65u-2026": {
        price: 109900,
        compare_at_price: 199900,
        img: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Q65U-MA-web1_3f7cbca6-16ce-4330-9ee5-3fda4ae6c5b6.jpg?v=1773626643",
      },
      "q75u-2026": {
        price: 139900,
        compare_at_price: 259900,
        img: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Q75U-MA-web1.jpg?v=1773626533",
      },
      "q85u-2026": {
        price: 229900,
        compare_at_price: 349900,
        img: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Q85U-MA-web1.jpg?v=1773626179",
      },

      "q43qe-2026": {
        price: 45900,
        compare_at_price: 99900,
        img: "https://prismplus.sg/cdn/shop/files/Q43-MA-web1.jpg?v=1772607670&width=345",
      },
      "q55qe-2026": {
        price: 59900,
        compare_at_price: 124900,
        img: "https://prismplus.sg/cdn/shop/files/Q55-MA-web1.jpg?v=1772607719&width=345",
      },
      "q65qe-2026": {
        price: 79900,
        compare_at_price: 164900,
        img: "https://prismplus.sg/cdn/shop/files/Q65-MA-web1.jpg?v=1772607780&width=345",
      },
      "q75qe-2026": {
        price: 119900,
        compare_at_price: 184900,
        img: "https://prismplus.sg/cdn/shop/files/Q75-MA-web1_72da47b4-c1b1-408a-b934-ed5b9264f514.jpg?v=1772609523&width=345",
      },

      "u55-2026": {
        price: 99900,
        compare_at_price: 309900,
        img: "https://prismplus.sg/cdn/shop/files/U55-web1_b6c1e322-039b-4fb4-88b5-5d70ded2dff8.jpg?v=1773626741&width=345",
      },
      "u65-2026": {
        price: 129900,
        compare_at_price: 359900,
        img: "https://prismplus.sg/cdn/shop/files/U65-web1_404336c9-dd89-4229-a6a6-9b5903e7f21d.jpg?v=1773626768&width=345",
      },
      "u75-2026": {
        price: 179900,
        compare_at_price: 609900,
        img: "https://prismplus.sg/cdn/shop/files/U75-web1_57e74a3d-b3fe-4127-90e5-c42c41185423.jpg?v=1773626801&width=345",
      },

      "prism-q100-ultra-qled-google-tv": {
        price: 399900,
        compare_at_price: 659900,
        img: "https://prismplus.sg/cdn/shop/files/Q100Ultra-Web1.jpg?v=1773626154&width=345",
      },

      "prism-u55-qd-mini-led": {
        price: 99900,
        compare_at_price: 309900,
        img: "https://prismplus.sg/cdn/shop/files/U55-web1_f40621b3-0ae5-46f8-aa67-63e11a614b15.jpg?v=1773626845&width=345",
      },
      "u75-qled-mini-led-google": {
        price: 179900,
        compare_at_price: 609900,
        img: "https://prismplus.sg/cdn/shop/files/U75-B-web1_a848a462-48d2-42ea-bf22-b472e162c0bf.jpg?v=1773626870&width=345",
      },
      "prism-u86-qd-mini-led": {
        price: 259900,
        compare_at_price: 799800,
        img: "https://prismplus.sg/cdn/shop/files/U86-web1_633dc298-387b-4dd6-82cd-0db611d9d1f7.jpg?v=1773626898&width=345",
      },

      "prism-u55-ultra-qd-mini-led-4k-ai-google-tv": {
        price: 169900,
        compare_at_price: 309900,
        img: "https://prismplus.sg/cdn/shop/files/U55U-web1_cec34c0c-e389-493d-aa4e-8dfb24a43b8d.jpg?v=1773626922&width=345",
      },
      "prism-u65-ultra-qd-mini-led-4k-ai-google-tv": {
        price: 229900,
        compare_at_price: 449900,
        img: "https://prismplus.sg/cdn/shop/files/U65U-web1_a89d5504-bfb5-4df5-9076-3906ec9fd7c6.jpg?v=1773626950&width=345",
      },
      "prism-u75-ultra-qd-mini-led-4k-ai-google-tv": {
        price: 299900,
        compare_at_price: 699900,
        img: "https://prismplus.sg/cdn/shop/files/U75U-web1_486a6ceb-88fb-4350-bd3a-2c757ce4bab7.jpg?v=1773626973&width=345",
      },
      "prism-u86-ultra-qd-mini-led-4k-ai-google-tv": {
        price: 399900,
        compare_at_price: 959900,
        img: "https://prismplus.sg/cdn/shop/files/U86U-web1_8d25a132-cf69-4946-8ccb-0ea0b596c223.jpg?v=1773627018&width=345",
      },

      "s32-google-tv": {
        price: 23900,
        compare_at_price: 57900,
        img: "https://prismplus.sg/cdn/shop/files/S32-web1_b16a2769-604b-406d-9d13-c9f97a702a64.jpg?v=1772692485&width=345",
      },
      "prism-s40-google-tv": {
        price: 31900,
        compare_at_price: 60900,
        img: "https://prismplus.sg/cdn/shop/files/S40-web1_e9f926aa-9f18-4c97-a3c6-deceb58c4f30.jpg?v=1772692556&width=345",
      },
      "prism-s43-google-tv": {
        price: 34900,
        compare_at_price: 53600,
        img: "https://prismplus.sg/cdn/shop/files/S43-web1_c41e8c60-5e53-409c-9307-d4920b24c398.jpg?v=1772692584&width=345",
      },

      "prism-55al-google-tv": {
        price: 189900,
        compare_at_price: 369900,
        img: "https://prismplus.sg/cdn/shop/files/55AL-web1_829242ed-a9f1-4dbc-a627-c17d888f14b3.jpg?v=1775440340&width=345",
      },
      "prism-65al-google-tv": {
        price: 269900,
        compare_at_price: 479900,
        img: "https://prismplus.sg/cdn/shop/files/65AL-web1_e86bb514-4e4e-4ba6-b475-3db22b8380fd.jpg?v=1775440362&width=345",
      },
    };

    return data;
  }

  function getDetails() {
    const icons = getIcons();

    const details = {
      "default-settings": [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],

      // Q Series Ultra 2026
      "q43u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "260 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "48W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "957.2 x 73.2 x 559.7 mm",
        "957.2 x 238.5 x 608.4 mm",
        "5.7 kg",
        "5.9 kg",
        "300 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q55u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "300 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "48W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1226 x 74 x 708.9 mm",
        "1226 x 308.7 x 776 mm",
        "9.1 kg",
        "9.2 kg",
        "300 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q65u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "320 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1445.6 x 83.2 x 834.3 mm",
        "1445.6 x 338 x 902.7 mm",
        "14 kg",
        "14.2 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q75u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "350 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1667.7 x 75 x 959.5 mm",
        "1667.7 x 398.7 x 1027.5 mm",
        "18.5 kg",
        "18.9 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q85u-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "QLED+",
        "4K (3840x2160)",
        "94% DCI-P3",
        "N/A",
        "400 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1890 x 91.3 x 1081.1 mm",
        "1890 x 398.3 x 1176.7 mm",
        "28.8 kg",
        "29.5 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // Q Ultra Series
      "prism-q55-ultra": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Dbx-TV"],
        icons["Eye-Care"],
        "QLED+",
        "4K (3840x2160)",
        "118% DCI-P3",
        "N/A",
        "N/A",
        "316 nits",
        "N/A",
        "120Hz (High-frame Scan Rate at 4k) or 120Hz VRR at FHD",
        "120 Smooth Motion",
        "HDR10+",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "40W",
        "N/A",
        "Yes",
        "Yes",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1225 x 80 x 721 mm",
        "1225 x 290 x 775 mm",
        "9.86 kg",
        "10.06 kg",
        "200 x 200",
        "1",
        "2",
        "N/A",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q75u-q75-ultra-qled-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Dbx-TV"],
        icons["Eye-Care"],
        icons["MEMC Real Motion"],
        "QLED+",
        "4K (3840x2160)",
        "91% DCI-P3",
        "N/A",
        "N/A",
        "447 nits",
        "N/A",
        "120Hz (High-frame Scan Rate at 4k) or 120Hz VRR at FHD",
        "120 Smooth Motion",
        "HDR10+",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "Yes",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1667 x 87 x 965 mm",
        "1667 x 320 x 1025 mm",
        "20.06 kg",
        "20.40 kg",
        "400 x 200",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-q100-ultra-qled-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Dbx-TV"],
        icons["Eye-Care"],
        icons["MEMC Real Motion"],
        "QLED",
        "4K (3840x2160)",
        "90% DCI-P3",
        "5000:1",
        "N/A",
        "600 nits",
        "N/A",
        "120Hz",
        "N/A",
        "HDR10+",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W + 2 x 10W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "2240 x 90 x 1270 mm",
        "2240 x 425 x 1350 mm",
        "72 kg",
        "73.50 kg",
        "800 x 400",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // Q QE Series 2026
      "q43qe-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons.HDR10,
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "",
        "VA",
        "4K (3840x2160)",
        "N/A",
        "N/A",
        "300 nits",
        "N/A",
        "N/A",
        "60Hz",
        "N/A",
        "HDR10",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "48W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "957.4 x 80.6 x 556.2 mm",
        "957.4 x 229.4 x 608.5 mm",
        "6.4 kg",
        "6.5 kg",
        "300 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q55qe-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons.HDR10,
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "VA",
        "4K (3840x2160)",
        "N/A",
        "N/A",
        "270 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "48W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1226 x 74 x 708.9 mm",
        "1226 x 308.7 x 776 mm",
        "9.1 kg",
        "9.2 kg",
        "300 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q65qe-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons.HDR10,
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "VA",
        "4K (3840x2160)",
        "N/A",
        "N/A",
        "320 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1445.6 x 83.2 x 834.3 mm",
        "1445.6 x 338 x 902.7 mm",
        "14 kg",
        "14.2 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q75qe-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons.HDR10,
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "VA",
        "4K (3840x2160)",
        "N/A",
        "N/A",
        "350 nits",
        "N/A",
        "N/A",
        "120Hz DLG *Feature must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1667.7 x 75 x 955.5 mm",
        "1667.7 x 398.7 x 1027.5 mm",
        "18.5 kg",
        "18.9 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // Q Series QE
      "q55qe-a-q55qe-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons.HDR10,
        icons["Dbx-TV"],
        icons["Eye-Care"],
        "IPS",
        "4K (3840x2160)",
        "93% DCI-P3",
        "N/A",
        "N/A",
        "340 nits",
        "N/A",
        "60Hz",
        "120 Smooth Motion",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "40W",
        "N/A",
        "Yes",
        "Yes",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1225 x 80 x 726 mm",
        "1225 x 260 x 782 mm",
        "9.74 kg",
        "9.92 kg",
        "200 x 200",
        "1",
        "2",
        "N/A",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "q65qe-a-q65qe-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        icons.HDR10,
        icons["Dbx-TV"],
        icons["Eye-Care"],
        "IPS",
        "4K (3840x2160)",
        "85% DCI-P3",
        "N/A",
        "N/A",
        "314 nits",
        "N/A",
        "60Hz",
        "120 Smooth Motion",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "60W",
        "N/A",
        "Yes",
        "Yes",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1447 x 80 x 840 mm",
        "1447 x 290 x 910 mm",
        "14.66 kg",
        "14.92 kg",
        "400 x 200",
        "1",
        "2",
        "N/A",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // U Series 2026
      "u55-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "92% DCI-P3",
        "1,000,000:1",
        "N/A",
        "900 nits",
        "N/A",
        "120Hz DLG *120Hz Game Mode must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1225.8 x 77.3 x 713.3 mm",
        "1225.8 x 291.5 x 776.3 mm",
        "12.5 kg",
        "12.8 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "u65-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "102% DCI-P3",
        "1,000,000:1",
        "N/A",
        "800 nits",
        "N/A",
        "120Hz DLG *120Hz Game Mode must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1445.2 x 78 x 834.2 mm",
        "1445.2 x 336.7 x 901.9 mm",
        "18 kg",
        "18.5 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "u75-2026": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+ Gaming"],
        icons["MEMC Real Motion"],
        icons["Apple Airplay"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "102% DCI-P3",
        "1,000,000:1",
        "N/A",
        "800 nits",
        "N/A",
        "120Hz DLG *120Hz Game Mode must be enabled in settings. Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10+ Gaming",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "N/A",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1667.3 x 78.3 x 959.3 mm",
        "1667.3 x 374.6 x 1026.5 mm",
        "25.5 kg",
        "26.2 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // U Series
      "prism-u55-qd-mini-led": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "93% DCI-P3",
        "1,000,000:1",
        "N/A",
        "550 nits",
        "N/A",
        "144Hz VRR (Variable Refresh Rate) *Subject to gaming console and PC graphics card compatibility.",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1233 x 88 x 721 mm",
        "1233 x 254 x 757 mm",
        "15.1 kg",
        "18.7 kg",
        "300 x 200",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "u65-qled-mini-led-google": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "93% DCI-P3",
        "1,000,000:1",
        "N/A",
        "600 nits",
        "N/A",
        "144Hz VRR (Variable Refresh Rate)",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1453 x 290 x 881 mm",
        "1453 x 88 x 845 mm",
        "22.5 kg",
        "27.8 kg",
        "400 x 200",
        "1",
        "2",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "u75-qled-mini-led-google": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "93% DCI-P3",
        "1,000,000:1",
        "N/A",
        "600 nits",
        "N/A",
        "144Hz VRR (Variable Refresh Rate) *Subject to gaming console and PC graphics card compatibility",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1675 x 330 x 1008 mm",
        "1675 x 88 x 973 mm",
        "32.9 kg",
        "40.2 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-u86-qd-mini-led": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "93% DCI-P3",
        "1,000,000:1",
        "N/A",
        "600 nits",
        "N/A",
        "144Hz VRR (Variable Refresh Rate) *Subject to gaming console and PC graphics card compatibility",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "1925 x 97 x 1109 mm",
        "1925x 380 x 1144 mm",
        "43.8 kg",
        "55 kg",
        "600 x 400",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // U Ultra-Series
      "prism-u55-ultra-qd-mini-led-4k-ai-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "110% DCI-P3",
        "1,000,000:1",
        "N/A",
        "1750 nits",
        "720",
        "144Hz",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "N/A",
        "1233 x 86.8 x 771.5 mm",
        "1233 x 230 x 721.6 mm",
        "14.9 kg",
        "15.2 kg",
        "300 x 200",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-u65-ultra-qd-mini-led-4k-ai-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Omniview"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "107% DCI-P3",
        "1,000,000:1",
        "N/A",
        "2250 nits",
        "1152",
        "144Hz",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "N/A",
        "1452.5 x 87.17 x 845.26 mm",
        "1452.5 x 324.92 x 904.14 mm",
        "22.2 kg",
        "22.6 kg",
        "400 x 200",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-u75-ultra-qd-mini-led-4k-ai-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Omniview"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "114% DCI-P3",
        "1,000,000:1",
        "N/A",
        "2040 nits",
        "1440",
        "144Hz",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "N/A",
        "1674.5 x 86.8 x 973.3 mm",
        "1674.5 x 325 x 1030.9 mm",
        "32.4 kg",
        "32.9 kg",
        "400 x 300",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-u86-ultra-qd-mini-led-4k-ai-google-tv": [
        icons["AI Processor"],
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["Omniview"],
        icons["144Hz"],
        icons["Dolby Vision"],
        icons["Dolby Atmos"],
        icons["HDR10+"],
        icons["Filmmaker Mode"],
        icons["MEMC Real Motion"],
        "",
        "",
        "Quantum Dot Mini-LED",
        "4K (3840x2160)",
        "110% DCI-P3",
        "1,000,000:1",
        "N/A",
        "2320 nits",
        "1800",
        "144Hz",
        "N/A",
        "HDR10",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "2 x 30W",
        "1 x 40W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "N/A",
        "1924.8 x 95.4 x 1109.4 mm",
        "1924.8 x 379.9 x 1178.4 mm",
        "43.0 kg",
        "43.8 kg",
        "600 x 400",
        "1",
        "1",
        "1",
        "1",
        "1",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // S Series
      "s32-google-tv": [
        icons["Google TV"],
        icons.HDR10,
        icons["Dolby Audio"],
        icons.DTS,
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "Direct LED (DLED)",
        "HD (1366 x 768)",
        "114% sRGB",
        "N/A",
        "N/A",
        "253 nits",
        "N/A",
        "N/A",
        "N/A",
        "HDR10",
        "N/A",
        "N/A",
        "Yes",
        "N/A",
        "2 x 20W",
        "N/A",
        "Yes",
        "N/A",
        "N/A",
        "N/A",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "718 x 70.2 x 426.8 mm",
        "718 x 177.6 x 466.6 mm",
        "3.48 kg",
        "3.52 kg",
        "200 x 200",
        "N/A",
        "N/A",
        "N/A",
        "2",
        "2",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-s40-google-tv": [
        icons["Google TV"],
        icons.HDR10,
        icons["Dolby Audio"],
        icons.DTS,
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "Direct LED (DLED)",
        "FHD (1920 x1080)",
        "117% sRGB",
        "N/A",
        "N/A",
        "253 nits",
        "N/A",
        "N/A",
        "N/A",
        "HDR10",
        "N/A",
        "N/A",
        "Yes",
        "N/A",
        "2 x 20W",
        "N/A",
        "Yes",
        "N/A",
        "Yes",
        "N/A",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "892 x 74.2 x 510.6 mm",
        "892 x 211.8x 556.6 mm",
        "4.7 kg",
        "4.81 kg",
        "200 x 100",
        "N/A",
        "N/A",
        "N/A",
        "2",
        "2",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-s43-google-tv": [
        icons["Google TV"],
        icons.HDR10,
        icons["Dolby Audio"],
        icons.DTS,
        icons["MEMC Real Motion"],
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "Direct LED (DLED)",
        "FHD (1920 x1080)",
        "106% sRGB",
        "N/A",
        "N/A",
        "228 nits",
        "N/A",
        "N/A",
        "N/A",
        "HDR10",
        "N/A",
        "N/A",
        "Yes",
        "N/A",
        "2 x 20W",
        "N/A",
        "Yes",
        "N/A",
        "Yes",
        "N/A",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "N/A",
        "N/A",
        "954.5 x 75.4 x 558.6 mm",
        "954.5 x 211.8 x 602.8 mm",
        "5.45 kg",
        "5.5 kg",
        "200 x 200",
        "N/A",
        "N/A",
        "N/A",
        "2",
        "2",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],

      // AL Series
      "prism-55al-google-tv": [
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision IQ"],
        icons["Dolby Atmos"],
        icons["Filmmaker Mode"],
        icons["HDR10+"],
        icons["MEMC Real Motion"],
        icons.DTS,
        "",
        "",
        "",
        "OLED",
        "4K (3840x2160)",
        "98.5% DCI-P3",
        "N/A",
        "N/A",
        "800 nits",
        "N/A",
        "120Hz ",
        "N/A",
        "HDR10+",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "2 x 12W + 2 x 5W",
        "20W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1225 x 50 x 710 mm",
        "1225 x 260 x 756 mm",
        "18.7 kg",
        "20.5 kg",
        "300 x 200",
        "1",
        "N/A",
        "2",
        "1",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
      "prism-65al-google-tv": [
        icons["Google TV"],
        icons["4K Ultra HD"],
        icons["120Hz New"],
        icons["Dolby Vision IQ"],
        icons["Dolby Atmos"],
        icons["Filmmaker Mode"],
        icons["HDR10+"],
        icons["MEMC Real Motion"],
        icons.DTS,
        "",
        "",
        "",
        "OLED",
        "4K (3840x2160)",
        "98.5% DCI-P3",
        "N/A",
        "N/A",
        "700 nits",
        "N/A",
        "120Hz ",
        "N/A",
        "HDR10+",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "2 x 12W + 2 x 5W",
        "20W",
        "Yes",
        "N/A",
        "Yes",
        "Yes",
        "Google Play Store",
        "Disney+, Netflix, Youtube, Prime Video, Spotify, HBO GO, Viu, Over 5000+ Apps",
        "Chromecast Built-In",
        "Yes",
        "Yes",
        "Yes",
        "Yes",
        "1450 x 50 x 835 mm",
        "1450 x 260 x 880 mm",
        "23 kg",
        "24.7 kg",
        "300 x 200",
        "1",
        "N/A",
        "2",
        "1",
        "N/A",
        "Yes",
        "Yes",
        "Yes",
        "Optical",
        "2.4GHz/5GHz",
        "Bluetooth 5.1",
      ],
    };

    return details;
  }

  function getDetailHeaders() {
    const headers = [
      "Panel Technology",
      "Resolution",
      "Colour Gamut",
      "Contrast Ratio",
      "Typical Brightness",
      "Peak Brightness",
      "Zones",
      "Refresh Rate",
      "Motion Rate",
      "HDR",
      "HLG",
      "Filmmaker Mode",
      "MEMC Motion Smoothing",
      "Dolby Vision",

      "Sound Output Speakers (Peak Power)",
      "Sound Output Subwoofer (Peak Power)",
      "Dolby Atmos",
      "Dbx-TV",
      "DTS TruSurround",

      "AI Processor",
      "App store",
      "Compatible Apps",
      "Casting",
      "Google Assistant Voice Control",
      "Digital TV Tuner",
      "Eye Care",
      "Bluetooth Audio",

      "Dimension w/o stand (LxWxH)",
      "Dimension w/ stand (LxWxH)",
      "Net Weight w/o stand",
      "Net Weight w/ stand",
      "VESA Mounting",

      "HDMI 2.1 with Enhanced Audio Return Channel (eARC)",
      "HDMI 2.1",
      "HDMI 2.0",
      "USB 2.0",
      "USB 3.0",
      "AV Input",
      "RF Input",
      "Ethernet Lan",
      "SPDIF Out",
      "Wi-Fi",
      "Bluetooth",
    ];

    return headers;
  }

  function getIcons() {
    const icons = {
      "AI Processor":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/AI_Processor_Icon_7ea5b1e8-5ebe-48bb-bf31-59b53768e6b7.png?v=1760087967",
      "Google TV":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Google_TV_Icon_c69d8cb0-7904-4bf2-926c-b4ee0c32df08.png?v=1760087967",
      "4K Ultra HD":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/4K_Ultra_HD_Icon_42e55df4-7723-4522-8708-492f4e41efba.png?v=1760087966",
      "120Hz":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/120Hz_Icon_39074d28-02c0-433b-8d4f-6b6490c3f15d.png?v=1760087967",
      "Dolby Vision":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dolby_Vision_Icon_bfb82158-81d3-48e8-a7c1-f0fe6f5a97fd.png?v=1760087966",
      "Dolby Atmos":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dolby_Atmos_Icon_eec9ad2a-55ca-4dd7-89f9-13736924ccca.png?v=1760087967",
      "HDR10+":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/HDR10_Icon_ae9d0293-df68-4937-b7c3-039d6ee82341.png?v=1760087966",
      "Filmmaker Mode":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Filmmaker_Mode_Icon_975463d3-8102-4d98-859c-16b03de2c335.png?v=1760087967",
      "MEMC Real Motion":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/MEMC_Real_Motion_Icon_2d35d8cb-8a7c-4e9c-a085-465400b8e9ba.png?v=1760087967",
      "Dbx-TV":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dbx-TV_Icon_ecd35df2-6d41-4de3-83b6-b3baf28a8d3a.png?v=1760087967",
      "Eye-Care":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Eye-Care_Icon_888b38e2-61e3-4837-a5c0-1442ab976bd8.png?v=1760087966",
      HDR10:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/HDR10_Icon_a7449031-6c69-46c6-a018-68711b50d8d2.png?v=1760087965",
      "144Hz":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/144Hz_Icon_ba9710fd-ba5f-4e43-8a5e-0df9eb4bd970.png?v=1760087966",
      "Dolby Vision IQ":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dolby_Vision_IQ_Icon_7319f882-8c1a-4a35-abb3-cdc2553ec92f.png?v=1760087966",
      "Dolby Audio":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Dolby_Audio_icon_48f32d34-e8e0-452b-987d-7557ab4e0cea.png?v=1760087966",
      DTS: "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/DTS_Icon_563f56fb-90ac-49a5-9dbb-42a6a10a89c2.png?v=1760087966",
      "Apple Airplay":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Apple_Airplay.jpg?v=1765515832",
      "120Hz New":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/120hz_icon_b793bf94-1475-4bd3-a3db-2b5d7f78f067.png?v=1766572727",
      "HDR10+ Gaming":
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/HDR10_Gaming_black.png?v=1773979307",
      Omniview:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Omniview.png?v=1775614539",
    };

    return icons;
  }

  async function getProduct(handle) {
    return await (await fetch(`/products/${handle}.js`)).json();
  }
})();
